import React, { useEffect, useState, useContext } from "react";
import { Award, FileText, Settings } from "lucide-react";

// styles
import styles from "./styles.module.css";
// components
import PersonalCard from "../../componentes/PersonalCard";
import QuickActions from "../../componentes/QuickActions";
import StatsCard from "../../componentes/StatsCard";
import RecentNotes from "../../componentes/RecentNotes";
import TotalReceivedCard from "../../componentes/TotalReceivedCard";
import UpgradeBanner from "../../componentes/UpgradeBanner";
// context
import { Context } from "../../context/UserContext";

function Dashboard() {
    const { user, summary, fetchSummary } = useContext(Context);
    // Controla qual card do QuickActions está expandido — fica aqui no
    // Dashboard para que o UpgradeBanner consiga abrir o card "Upgrade"
    // diretamente, sem precisar de popups ou navegação extra.
    const [expandedCard, setExpandedCard] = useState(null);
    const token = JSON.parse(localStorage.getItem('token')) || '';

    useEffect(() => {
        fetchSummary(token);
    }, []);


    if(!user){
        return(
            <div className={styles.loading}>
                <p>Carregando informações do usuário...</p>
            </div>
        )
    }

    return (
        <section className={styles.container}>
            <PersonalCard name={user?.name} plan={user?.plan} email={user?.email} phone={user?.phone} cnpj={user?.cnpj} localization={user?.localization} />
            <QuickActions expandedCard={expandedCard} setExpandedCard={setExpandedCard} />
            {/* Banner estático de upgrade — só aparece para plano gratuito */}
            {user?.plan === 'free' && (
                <UpgradeBanner onUpgradeClick={() => setExpandedCard('Upgrade')} />
            )}
            <TotalReceivedCard summary={summary} />
            <StatsCard user={user} />
            <RecentNotes />
        </section>
    )
}
export default Dashboard